<section
  class="bg-white dark:bg-gray-900 pt-8 md:pt-20 px-4 text-gray-900 dark:text-white"
>
  <div class="flex flex-col text-center">
    <h1 class="text-2xl lg:text-6xl font-extrabold pb-4 mb-8">
      Wir unterstützen Sie bei Ihre Personalsuche
    </h1>
  </div>
  <div class="mb-12">
    <div class="flex flex-col md:flex-row rounded-lg mt-4">
      <div class="flex w-full md:w-1/2 items-center">
        <img
          ngSrc="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/recruiting_md_laurenz_kleinheider_dedc6096c8.webp"
          priority
          srcset="
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/recruiting_sm_laurenz_kleinheider_3c3c3e7779.webp  640w,
          https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/recruiting_md_laurenz_kleinheider_dedc6096c8.webp 1920w
          "
          sizes="(max-width: 768px) 640px, 1920px"
          width="1920"
          height="1280"
          alt="Recruiting"
          class="rounded-lg"
        />
      </div>
      <div class="w-full md:w-1/2 py-4 md:pl-4 content-baseline">
        <h1 class="text-4xl font-bold mb-8">Unser Expertise ist Eure Glück!</h1>
        <p class="py-2 text-lg">
          Unsere Expertise im Recruiting konzentriert sich darauf, die
          Top-Talents aus nicht-EU Länder (aktuell hauptsächlich aus dem Iran)
          für Ihr Unternehmen zu gewinnen.
        </p>
        <p class="py-2 text-lg">
          Egal, ob Start-up, mittelständisches Unternehmen oder Großkonzern,
          unsere individuellen Lösungen im Bereich Personalbeschaffung ist
          darauf ausgerichtet, Ihr Team mit hochqualifizierten Fach- und
          Führungskräften aus dem Ausland zu verstärken.
        </p>
        <p class="py-2 text-lg">
          In einem gemiensamen Prozess werden wir die am meisten passende
          Fachkraft mit ihrem gewünschten Qualifikationen und Erfahrungen finden
        </p>
        <p class="py-2 text-lg">
          Das Recruiting ist bis zum erfolgreichen Vermittlung für Sie kostenlos
        </p>
      </div>
    </div>
  </div>
</section>

<section
  class="bg-white dark:bg-gray-900 pt-8 md:pt-20 px-4 text-gray-900 dark:text-white"
>
  <div class="flex flex-col items-center">
    <h1 class="text-2xl lg:text-4xl font-extrabold pb-4 text-center">
      Das spricht für unsere Kandidaten
    </h1>
    <h3 class="text-lg max-w-6xl text-center">
      Wir Suchen Ihre mögliche Arbeitneher sorgfälltig und mit viel Analyse.
      Damit sichern wir, dass die mögliche Arbeitnehmer die höhen Anspruche von
      der zukünfitigen Arbeitstelle gerecht werden kann. wir sind stets bemüht
      dass unsere Kandidaten mindestens folgende Qualifikationonen und Wertde
      mit sich bringen.
    </h3>
    <div
      class="flex flex-col sm:flex-row gap-12 text-center pb-12 pt-8 sm:py-8"
    >
      <div class="min-w-[12rem]">
        <div class="flex justify-center">
          <img
            src="/assets/icons/for-employers/language-level.svg"
            alt=""
            class="w-20 h-20"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
          />
        </div>
        <div>
          Sprachniveau B1
          <br />
          <span>(Deutsch oder Englisch)</span>
        </div>
      </div>

      <div class="min-w-[12rem]">
        <div class="flex justify-center">
          <img
            src="/assets/icons/for-employers/academic-certification.svg"
            alt=""
            class="w-20 h-20"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
          />
        </div>
        <div>Akademische Ausbildung</div>
      </div>

      <div class="min-w-[12rem]">
        <div class="flex justify-center">
          <img
            src="/assets/icons/for-employers/committed.svg"
            alt=""
            class="w-20 h-20"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
          />
        </div>
        <div>Engagiert und motiviert</div>
      </div>
    </div>

    <div
      class="flex flex-col sm:flex-row gap-12 text-center pb-12 pt-8 sm:py-8"
    >
      <div class="min-w-[12rem]">
        <div class="flex justify-center">
          <img
            src="/assets/icons/for-employers/multitasking.svg"
            alt=""
            class="w-20 h-20"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
          />
        </div>
        <div>Leistungsbereit</div>
      </div>

      <div class="min-w-[12rem]">
        <div class="flex justify-center">
          <img
            src="/assets/icons/for-employers/team-work.svg"
            alt=""
            class="w-20 h-20"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
          />
        </div>
        <div>Teamfähigkeit</div>
      </div>

      <div class="min-w-[12rem]">
        <div class="flex justify-center">
          <img
            src="/assets/icons/for-employers/adaptable.svg"
            alt=""
            class="w-20 h-20"
            [class.grey-svg]="(activeTheme$ | async) === 'dark'"
          />
        </div>
        <div>Annpassungsfähig</div>
      </div>
    </div>
  </div>
</section>

<section
  class="bg-white dark:bg-gray-900 pt-8 md:pt-20 px-4 text-gray-900 dark:text-white"
>
  <div id="fieldOfactivity">
    <h1 class="text-2xl lg:text-4xl font-extrabold pb-4 text-center">
      Wir vermitteln Fachkräfte von ausländischen Fachkräften vor allem in den
      Bereichen:
    </h1>
    <div
      class="flex flex-col sm:flex-row gap-8 rounded-t-lg py-12 xl:px-40 xxl:px-48"
    >
      <div
        class="flex flex-col bg-slate-200 dark:bg-gray-800 rounded-xl items-center"
      >
        <div>
          <img
            src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/healthcare_md_hush_naidoo_887b4d7c39.webp"
            srcset="
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/healthcare_sm_hush_naidoo_3a43d100a6.webp  640w,
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/healthcare_md_hush_naidoo_887b4d7c39.webp 1920w
            "
            sizes="(max-width: 768px) 640px, 1920px"
            width="1920"
            height="1280"
            alt="Gesundheitswesen"
            class="rounded-t-lg"
          />
        </div>
        <h1 class="my-6 text-xl">Gesundheitswesen</h1>
      </div>

      <div
        class="flex flex-col bg-slate-200 dark:bg-gray-800 rounded-xl items-center"
      >
        <div>
          <img
            src="https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/engineering_md_thisisengineering_a5bafb0c24.webp"
            srcset="
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/engineering_sm_thisisengineering_396362074a.webp  640w,
            https://almanjobs-strapi-public-bucket.s3-eu-central-2.ionoscloud.com/engineering_md_thisisengineering_a5bafb0c24.webp 1920w
            "
            sizes="(max-width: 768px) 640px, 1920px"
            width="1920"
            height="1280"
            alt="Ingenieurwesen"
            class="rounded-t-lg"
          />
        </div>
        <h1 class="my-6 text-xl">Ingenieurwesen</h1>
      </div>
    </div>
  </div>
</section>

<section
  class="bg-white dark:bg-gray-900 pt-8 md:pt-20 px-4 text-gray-900 dark:text-white"
>
  <div class="pt-5">
    <h1 class="text-2xl lg:text-4xl font-extrabold text-center">
      Unserer Recruiting-Prozess erfolgt in 4 Schritten:
    </h1>
    <div
      class="grid grid-cols-1 xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mt-8"
    >
      <div class="flex flex-col items-center border rounded-lg">
        <img
          src="/assets/icons/for-employers/report-vacancy.svg"
          alt=""
          class="w-40 h-40"
          [class.grey-svg]="(activeTheme$ | async) === 'dark'"
        />
        <div class="p-4">
          <h1 class="text-xl mb-2">1. Gemeinsames Briefing</h1>
          <p>
            Sie informieren uns über die Arbeitstelle, die besetzte werden muss.
            Wir setzen uns umgehend Mit Ihenen im Kontakt und besprechen alle
            Anforderungen. Anschließend wird Ihr Stellenangebot auf unsere
            Webseite online gestellt
          </p>
        </div>
      </div>
      <div class="flex flex-col items-center border rounded-lg">
        <img
          src="/assets/icons/for-employers/employees-search.svg"
          alt=""
          class="w-40 h-40"
          [class.grey-svg]="(activeTheme$ | async) === 'dark'"
        />
        <div class="p-4">
          <h1 class="text-xl mb-2">2. Passende Kandidaten finden</h1>
          <p>
            Wir suchen in unserem Benutzerdatenbank nach potenzielle Fachkräfte.
            Wenn sich keine Passende finden lässt, warten wir auf potenzielle
            Bewerber für die Arbeitstelle. Wir treffen einen Vorauswahl und
            führen erste Gespräche und prüfen, ob der Kandidat zu Ihrem
            Unternehmen passt.
          </p>
        </div>
      </div>
      <div class="flex flex-col items-center border rounded-lg">
        <img
          src="/assets/icons/for-employers/select-employee2.svg"
          alt=""
          class="w-40 h-40"
          [class.grey-svg]="(activeTheme$ | async) === 'dark'"
        />
        <div class="p-4">
          <h1 class="text-xl mb-2">3. Auswahl der Personal</h1>
          <p>
            Sobald wir den passenden Personal gefunden haben, setzen wir uns mit
            Ihnen im KOntakt und besprechen unsere Erkenntnisse. Auf wünsch
            organisieren wir einen weiteren Interview gemeinsam mit Ihenen, um
            sicher zu gehen, dass die ausgewählte Fachkraft gänzlich Ihren
            Anforderungen erfüllen kann.
          </p>
        </div>
      </div>
      <div class="flex flex-col items-center border rounded-lg">
        <img
          src="/assets/icons/for-employers/emigrate-and-work.svg"
          alt=""
          class="w-40 h-40"
          [class.grey-svg]="(activeTheme$ | async) === 'dark'"
        />
        <div class="p-4">
          <h1 class="text-xl mb-2">
            4. Vertragschließung und Migration nach Deustchland
          </h1>
          <p>
            Sobald wir den passenden Personal gefunden haben, setzen wir uns mit
            Ihnen im KOntakt und besprechen unsere Erkenntnisse. Auf wünsch
            organisieren wir einen weiteren Interview gemeinsam mit Ihenen, um
            sicher zu gehen, dass die ausgewählte Fachkraft gänzlich Ihren
            Anforderungen erfüllen kann.
          </p>
        </div>
      </div>
    </div>
  </div>
</section>

<section
  class="bg-white dark:bg-gray-900 pt-8 md:pt-20 px-4 text-gray-900 dark:text-white"
>
  <div id="employerInquiry" class="my-20">
    <h1 class="text-2xl lg:text-4xl py-2">Ihre Anfrage</h1>
    <h3 class="pb-8">
      Nutzen Sie das Kontaktformular für Ihre Anfrage, wir melden uns umgehend
      bei Ihnen zurück.
    </h3>
    <form [formGroup]="employerInquiryFrom" (ngSubmit)="onFormSubmit()">
      <div class="grid grid-cols-5 gap-6">
        <div id="companyName" class="col-span-6 sm:col-span-3">
          <label
            for="companyName"
            class="block mb-1 ml-1 text-sm font-medium text-gray-900 dark:text-white"
            >Name des Unternehmens*
          </label>
          <input
            formControlName="companyName"
            type="text"
            name="companyName"
            id="companyName"
            class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            required
          />
        </div>
        <div id="inquirer" class="col-span-6 sm:col-span-3">
          <label
            for="inquirer"
            class="block mb-1 ml-1 text-sm font-medium text-gray-900 dark:text-white"
          >
            Ihr Name*
          </label>
          <input
            formControlName="inquirer"
            type="text"
            name="inquirer"
            id="inquirer"
            class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            aria-describedby="lastnameHelp"
            required
          />
        </div>
        <div id="inquiredPosition" class="col-span-6 sm:col-span-3">
          <label
            for="inquiredPosition"
            class="block mb-1 ml-1 text-sm font-medium text-gray-900 dark:text-white"
            >Gesuchte Position*
          </label>
          <input
            formControlName="inquiredPosition"
            type="text"
            name="inquiredPosition"
            id="inquiredPosition"
            class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            placeholder="Z.B. Java Entwickler"
            required
          />
        </div>
        <div id="city" class="col-span-6 sm:col-span-3">
          <label
            for="city"
            class="block mb-1 ml-1 text-sm font-medium text-gray-900 dark:text-white"
            >Ort*
          </label>
          <input
            formControlName="city"
            type="text"
            name="city"
            class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
            placeholder="Z.B. Dortmund"
            required
          />
        </div>
        <div class="col-span-6 sm:col-span-3">
          <label
            for="email"
            class="block ml-1 mb-1 text-sm font-medium text-gray-900 dark:text-white"
            >Ihre E-Mail-Adresse*</label
          >
          <input
            formControlName="email"
            type="email"
            name="email"
            id="email"
            class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          />
          <div
            *ngIf="
              employerInquiryFrom.get('email')?.invalid &&
              employerInquiryFrom.get('email')?.touched">
            <div *ngIf="employerInquiryFrom.get('email')?.invalid">
              <div
                class="p-1 mt-1 text-xs text-red-800 rounded-md dark:text-red-400"
                role="alert">
                <span class="font-medium">
                  Bitte verwenden Sie eine valide E-Mail-Adresse
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-span-6 sm:col-span-3">
          <label
            for="phoneNumber"
            class="block ml-1 mb-1 text-sm font-medium text-gray-900 dark:text-white"
            >Ihre Telefonnummer</label
          >
          <div class="flex items-center">
            <button
              id="dropdown-phone-button"
              class="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600"
              type="button"
            >
              <div class="inline-flex items-center">
                <img
                  class="w-4 h-4 rounded-full mr-2"
                  src="assets/icons/flags/de.svg"
                  alt="german flag"
                  loading="lazy"
                />
                Deutschland(+49)
              </div>
            </button>
            <div class="relative w-full">
              <input
                type="text"
                formControlName="phoneNumber"
                id="phone-input"
                class="block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-e-lg border-s-0 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-s-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                placeholder="151 23456789"
                required
              />
            </div>
          </div>
        </div>
        <div class="col-span-6 sm:col-span-3">
          <label
            for="message"
            class="block ml-1 mb-1 text-sm font-medium text-gray-900 dark:text-white"
          >
            Ihre Nachricht
          </label>
          <textarea
            formControlName="message"
            type="text"
            name="message"
            class="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
          >
          </textarea>
        </div>
        <div class="sm:row-start-5 col-span-5 flex items-center mb-4">
          <div class="flex flex-col">
            <div>
              <input
                id="DatenschutzCheckbox"
                formControlName="dataPrivacyConcent"
                type="checkbox"
                value=""
                class="w-4 h-4 text-blue-600 bg-gray-100 rounded focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700"
                [ngClass]="{'focus:ring-red-500 dark:focus:ring-red-600 border-red-500 dark:border-red-600': mustCheckDatenschutz}"

              />
              <label
                for="dataPrivacyConcent"
                class="ms-2 text-sm font-medium text-gray-900 dark:text-gray-300"
              >
                Ich habe die Datenschutzbestimmungen gelesen und stimme diesen zu*.
              </label>
            </div>
            @if(mustCheckDatenschutz){
              <div class="text-sm text-red-800 dark:text-red-400">
                Bitte bestätigen sie unsere Datenschutzbestimmungen um eine Anfrage zu versenden.
              </div>
            }
          </div>
        </div>
        @if(inquerySuccessfull | async){
          <div
          class="flex col-span-6 sm:col-full items-center p-4 mb-4 text-sm text-green-800 border border-green-300 rounded-lg bg-red-50 dark:bg-gray-800 dark:text-green-400 dark:border-green-800"
          role="alert">
            <img
              src="assets/icons/info-green.svg"
              class="flex-shrink-0 inline w-4 h-4 me-3"
              aria-hidden="true"
              alt="Almanjobs logo"
            />
            <div>
              Ihre Anfrage wurde erfolregich versendet
            </div>
          </div>
        }
        <div class="flex col-end-6 col-span-6 sm:col-full">
          <button
            type="submit"
            [disabled]="inquerySuccessfull | async"
            class="w-full md:w-auto text-white bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800 disabled:opacity-50"
          >
            Absenden
          </button>
        </div>
      </div>
    </form>
  </div>
</section>
